import script from "./FormHtml.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormHtml.vue?vue&type=script&setup=true&lang=ts"

import "./FormHtml.vue?vue&type=style&index=0&id=c86197e0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c86197e0"]])

export default __exports__